
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/3cat/entreteniment",
      function () {
        return require("private-next-pages/3cat/entreteniment/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/3cat/entreteniment"])
      });
    }
  